export default {
  props: {
    listKey: String,
    row: Object,
    data: Object,
    index: Number,
  },
  data: () => ({
    selected: false,
    useData: false,
  }),
  methods: {
    toggleSelected() {
      // if(this.isPopupMode) return
      if(this.selected === this.isRowSelected) return

      if(this.selected == true) {
        this.$store.dispatch(`list/${this.listKey}/select`, window.eagleLodash.cloneDeep(this.selectedData))
        return
      }

      this.$store.dispatch(`list/${this.listKey}/unselect`, window.eagleLodash.cloneDeep(this.selectedData))
    },
    usedListMatchCallback(userListRow) {
      if(!this.popupConfig) return false
      if(typeof this.popupConfig.usedListMatchCallback == 'function') {
        return this.popupConfig.usedListMatchCallback(userListRow, this.useData ? this.data: this.row)
      }
      if (this.useData) {
        return userListRow.id == this.data.id
      } else {
        return userListRow.id == this.row.id
      }
    },
  },
  computed: {
    selectedData() {
      const defaultSelectedData = { [this.targetKey]: this.target }
      if(!this.listConfig) return defaultSelectedData
      if(typeof this.listConfig.selectedData === 'function') {
        if (this.useData) {
          return this.listConfig.selectedData(this.data)
        } else {
          return this.listConfig.selectedData(this.row)
        }
      }
      return { [this.targetKey]: this.target }
    },
    disabledSelect() {
      if(!this.popupConfig) return false
      if(!Array.isArray(this.popupConfig.usedList)) return true
      return !!this.popupConfig.usedList.find(this.usedListMatchCallback)
    },
    target() {
      if (this.useData) {
        return this.data?.[this.targetKey]
      } else {
        return this.row?.[this.targetKey]
      }
    },
    targetKey() {
      return this.$store.getters[`list/${this.listKey}/targetKey`]
    },
    isPopupMode() {
      return this.$store.getters[`list/${this.listKey}/isPopupMode`]
    },
    listConfig() {
      return this.$store.getters[`list/${this.listKey}/config`]
    },
    popupConfig() {
      return this.$store.getters[`list/${this.listKey}/popupConfig`]
    },
    listSelected: {
      get() {
        return this.$store.getters[`list/${this.listKey}/selected`]
      },
      set(value) {
        this.$store.dispatch(`list/${this.listKey}/setSelected`, value)
      },
    },
    isRowSelected() {
      return !!window.eagleLodash.find(this.listSelected, this.selectedData)
    },
  },
  watch: {
    isRowSelected: {
      immediate: true,
      handler() {
        this.selected = window.eagleLodash.cloneDeep(this.isRowSelected)
      },
    },
    // selected: {
    //   handler() {
    //     this.toggleSelect
    //   },
    // },
  },
}
